"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderArray = exports.splitArrayToChunks = exports.arrayIncludes = exports.isNonArrayObject = exports.sameArrayValues = exports.hasDuplicates = void 0;
const nullables_1 = require("./nullables");
// eslint-disable-next-line functional/prefer-immutable-types
const hasDuplicates = (arr) => arr.length !== new Set(arr).size;
exports.hasDuplicates = hasDuplicates;
// eslint-disable-next-line functional/prefer-immutable-types
const sameArrayValues = (values) => new Set(values).size === 1;
exports.sameArrayValues = sameArrayValues;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isNonArrayObject = (value) => (0, nullables_1.hasValue)(value) && typeof value === 'object' && !Array.isArray(value);
exports.isNonArrayObject = isNonArrayObject;
const arrayIncludes = (array, element) => array.includes(element);
exports.arrayIncludes = arrayIncludes;
// eslint-disable-next-line functional/prefer-immutable-types
const splitArrayToChunks = (list, chunkSize) => 
// eslint-disable-next-line functional/prefer-immutable-types
list.reduce((chunks, item, index) => {
    const chunk = Math.floor(index / chunkSize);
    // eslint-disable-next-line functional/immutable-data
    chunks[chunk] = [].concat(chunks[chunk] ?? [], item);
    return chunks;
}, []);
exports.splitArrayToChunks = splitArrayToChunks;
// eslint-disable-next-line functional/prefer-immutable-types
const reorderArray = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    // eslint-disable-next-line functional/immutable-data
    const [removed] = result.splice(startIndex, 1);
    // eslint-disable-next-line functional/immutable-data
    result.splice(endIndex, 0, removed);
    return result;
};
exports.reorderArray = reorderArray;
